import(/* webpackMode: "eager" */ "/quick/apps/pwa/app/[lang]/login/page.tsx");
